import { deviceTypes } from "./deviceTypes"
import { privileges } from "./auth"
import semver from "semver"

export const alarmTypeProperties = {
	LFP_BMS_UNRESPONSIVE: {
		name: "LFP BMS Unresponsive",
		privilege: privileges.GAMECHANGE,
	},
	NO_TIME_SINCE_RESET: {
		name: "No Time Since Reset",
		privilege: privileges.GAMECHANGE,
	},
	NO_COMM_WITH_MASTER: {
		name: "No Communications",
		privilege: privileges.VIEW,
	},
	MOTOR_OVERCURRENT_HW: {
		name: "Motor Overcurrent (HW)",
		privilege: privileges.VIEW,
	},
	MOTOR_OVERCURRENT_SW: {
		name: "Motor Overcurrent (SW)",
		privilege: privileges.VIEW,
	},
	AXIS_BLOCKED: {
		name: "Axis Blocked",
		privilege: privileges.VIEW,
	},
	LOW_SPEED: {
		name: "Motor Low Speed",
		privilege: privileges.VIEW,
	},
	MOTOR_OVERCURRENT: {
		name: "Actuator Over Current Shutdown",
		privilege: privileges.VIEW,
	},
	BATTERY_LIMITED: {
		name: "Battery Limited",
		privilege: privileges.VIEW,
	},
	BATTERY_NOT_ENOUGH: {
		name: "Battery Not Enough",
		privilege: privileges.VIEW,
	},
	BATTERY_LOW_STOW: {
		name: "Battery Low",
		privilege: privileges.VIEW,
	},
	BATTERY_CRITICAL_STOW: {
		name: "Battery Critical",
		privilege: privileges.VIEW,
	},
	ANGLE_OUT_OF_SYSTEM_MAX_RANGE: {
		name: "Angle Out of System Max Range",
		privilege: privileges.GAMECHANGE,
	},
	READ_FLASH_ERROR: {
		name: "Memory Read Error",
		privilege: privileges.GAMECHANGE,
	},
	WRITE_FLASH_ERROR: {
		name: "Memory Write Error",
		privilege: privileges.GAMECHANGE,
	},
	TRACKING_DISABLED: {
		name: "Tracking Disabled",
		privilege: privileges.VIEW,
	},
	ESTOP_PUSHED: {
		name: "E-Stop Pushed",
		privilege: privileges.VIEW,
	},
	NO_MOTION: {
		name: "Actuator Not Responding",
		privilege: privileges.VIEW,
	},
	WRONG_DIRECTION: {
		name: "Reverse Actuator Connection",
		privilege: privileges.VIEW,
	},
	BATTERY_OVERCHARGING: {
		name: "Battery Overcharge Shutdown",
		privilege: privileges.VIEW,
	},
	OTA_CRC_CHECK_FAILED: {
		name: "OTA CRC Check Failed",
		privilege: privileges.GAMECHANGE,
	},
	NODE_ASSIGNED_INIT_VALUES: {
		name: "No Data Available (Node)",
		privilege: privileges.GAMECHANGE,
	},
	NOT_CHARGING: {
		name: "Not Charging",
		privilege: privileges.VIEW,
	},
	OTA_IMG_PARAM_SAVE_ERROR: {
		name: "OTA IMG Param Save",
		privilege: privileges.GAMECHANGE,
	},
	BAD_CHARGING_PANEL: {
		name: "Bad Charging Panel",
		privilege: privileges.GAMECHANGE,
	},
	TABLE_OUTSIDE_TRACKING_LIMITS: {
		name: "Table Outside Tracking Limits",
		privilege: privileges.GAMECHANGE,
	},
	MASTER_ASSIGNED_INIT_VALUES: {
		name: "No Data Available (Master)",
		privilege: privileges.CONTROL_CX,
	},
	OTA_RETRIES_REACHED: {
		name: "OTA Retries Reached",
		privilege: privileges.GAMECHANGE,
	},
	LOW_TEMP_STOW: {
		name: "Low Temperature Stow",
		privilege: privileges.VIEW,
	},
	ANGLE_DEVIATION_FROM_MASTER: {
		name: "Angle Deviation",
		privilege: privileges.DEV,
	},
	CHARGER_FIRMWARE_BROKEN: {
		name: "Alarm Charger Firmware Broken",
		privilege: privileges.VIEW,
	},
	CHARGER_COMM_ERROR: {
		name: "Alarm Charger Communication Error",
		privilege: privileges.VIEW,
	},
	DUPLICATE_NODEID: {
		name: "Duplicate Node ID",
		privilege: privileges.VIEW,
	},
	OLD_DATA: {
		name: "Old Data",
		privilege: privileges.VIEW,
	},
	BATTERY_LOW_DURING_MOTION: {
		name: "Battery Low During Motion",
		privilege: privileges.VIEW,
	},
	NO_DATA_IN_DATABASE: {
		name: "No Data Available in Server",
		privilege: privileges.VIEW,
	},
	UNKNOWN_ACCELEROMETER_TYPE: {
		name: "Unknown Accelerometer Type",
		privilege: privileges.GAMECHANGE,
	},
	BATTERY_MAINTENANCE: {
		name: "Battery Maintenance",
		privilege: privileges.VIEW,
	},
	INCLINOMETER_DISCONNECTED: {
		name: "Inclinometer Disconnected",
		privilege: privileges.GAMECHANGE,
	},
	TEMPERATURE_SHUTDOWN: {
		name: "Temperature Shutdown",
		privilege: privileges.VIEW,
	},
	BATTERY_SHUTDOWN: {
		name: "Battery Shutdown",
		privilege: privileges.VIEW,
	},
	LFP_BATTERY_SOC_LOW: {
		name: "LFP Battery SOC Low",
		privilege: privileges.VIEW,
	},
	LFP_BATTERY_SOC_CRITICAL: {
		name: "LFP Battery SOC Critical",
		privilege: privileges.VIEW,
	},
}

const nodeAlarmEnums = {
	LFP_BMS_UNRESPONSIVE: 1n << 0n,
	NO_TIME_SINCE_RESET: 1n << 1n,
	NO_COMM_WITH_MASTER: 1n << 2n,
	MOTOR_OVERCURRENT: 1n << 3n,
	BATTERY_LOW_STOW: 1n << 4n,
	BATTERY_CRITICAL_STOW: 1n << 5n,
	ANGLE_OUT_OF_SYSTEM_MAX_RANGE: 1n << 6n,
	READ_FLASH_ERROR: 1n << 7n,
	WRITE_FLASH_ERROR: 1n << 8n,
	TRACKING_DISABLED: 1n << 9n,
	ESTOP_PUSHED: 1n << 10n,
	NO_MOTION: 1n << 11n,
	WRONG_DIRECTION: 1n << 12n,
	BATTERY_OVERCHARGING: 1n << 13n,
	OTA_CRC_CHECK_FAILED: 1n << 14n,
	NODE_ASSIGNED_INIT_VALUES: 1n << 15n,
	NOT_CHARGING: 1n << 16n,
	LFP_BATTERY_SOC_LOW: 1n << 17n,
	LFP_BATTERY_SOC_CRITICAL: 1n << 18n,
	OTA_IMG_PARAM_SAVE_ERROR: 1n << 19n,
	BAD_CHARGING_PANEL: 1n << 20n,
	TABLE_OUTSIDE_TRACKING_LIMITS: 1n << 21n,
	MASTER_ASSIGNED_INIT_VALUES: 1n << 22n,
	OTA_RETRIES_REACHED: 1n << 23n,
	LOW_TEMP_STOW: 1n << 24n,
	ANGLE_DEVIATION_FROM_MASTER: 1n << 25n,
	BATTERY_LOW_DURING_MOTION: 1n << 26n,
	UNKNOWN_ACCELEROMETER_TYPE: 1n << 27n,
	BATTERY_MAINTENANCE: 1n << 28n,
	INCLINOMETER_DISCONNECTED: 1n << 29n,
	TEMPERATURE_SHUTDOWN: 1n << 30n,
	BATTERY_SHUTDOWN: 1n << 31n,
}

export const allNodeAlarmTypes = Object.keys(nodeAlarmEnums)

export const nodeAlarmEnumsByDeviceType = {
	[deviceTypes.GAMECHANGE_GEN2]: nodeAlarmEnums,
	[deviceTypes.GAMECHANGE_GEN3]: nodeAlarmEnums,
	[deviceTypes.GAMECHANGE_GEN4]: {
		LFP_BMS_UNRESPONSIVE: 1n << 0n,
		NO_TIME_SINCE_RESET: 1n << 1n,
		NO_COMM_WITH_MASTER: 1n << 2n,
		MOTOR_OVERCURRENT: 1n << 3n,
		BATTERY_LOW_STOW: 1n << 4n,
		BATTERY_CRITICAL_STOW: 1n << 5n,
		ANGLE_OUT_OF_SYSTEM_MAX_RANGE: 1n << 6n,
		READ_FLASH_ERROR: 1n << 7n,
		WRITE_FLASH_ERROR: 1n << 8n,
		TRACKING_DISABLED: 1n << 9n,
		ESTOP_PUSHED: 1n << 10n,
		NO_MOTION: 1n << 11n,
		WRONG_DIRECTION: 1n << 12n,
		BATTERY_OVERCHARGING: 1n << 13n,
		OTA_CRC_CHECK_FAILED: 1n << 14n,
		NODE_ASSIGNED_INIT_VALUES: 1n << 15n,
		NOT_CHARGING: 1n << 16n,
		LFP_BATTERY_SOC_LOW: 1n << 17n,
		LFP_BATTERY_SOC_CRITICAL: 1n << 18n,
		OTA_IMG_PARAM_SAVE_ERROR: 1n << 19n,
		BAD_CHARGING_PANEL: 1n << 20n,
		TABLE_OUTSIDE_TRACKING_LIMITS: 1n << 21n,
		MASTER_ASSIGNED_INIT_VALUES: 1n << 22n,
		OTA_RETRIES_REACHED: 1n << 23n,
		LOW_TEMP_STOW: 1n << 24n,
		ANGLE_DEVIATION_FROM_MASTER: 1n << 25n,
		CHARGER_FIRMWARE_BROKEN: 1n << 26n,
		CHARGER_COMM_ERROR: 1n << 27n,
	},
	[deviceTypes.GAMECHANGE_GEN3_DUAL_PRIMARY]: nodeAlarmEnums,
	[deviceTypes.GAMECHANGE_GEN3_DUAL_AUX]: {
		LFP_BMS_UNRESPONSIVE: 1n << 0n,
		NO_COMM_WITH_MASTER: 1n << 1n,
		INVALID_TRACKING_PARAM: 1n << 2n,
		READ_FLASH_ERROR: 1n << 3n,
		WRITE_FLASH_ERROR: 1n << 4n,
		MOTOR_OVERCURRENT: 1n << 5n,
		NO_MOTION: 1n << 6n,
		WRONG_DIRECTION: 1n << 7n,
		NODE_ASSIGNED_INIT_VALUES: 1n << 8n,
		OTA_CRC_CHECK_FAILED: 1n << 9n,
		OTA_IMG_PARAM_SAVE_ERROR: 1n << 11n,
		BAD_CHARGING_PANEL: 1n << 12n,
		TABLE_OUTSIDE_TRACKING_LIMITS: 1n << 13n,
	},
}

// The maximum safe number a JavaScript Number can hold has 52 bits.
const _javaScriptNumberSize = 52n
export const NO_DATA_IN_DATABASE = 1n << (_javaScriptNumberSize - 1n)
export const DUPLICATE_NODEID = 1n << (_javaScriptNumberSize - 2n)
export const OLD_DATA = 1n << (_javaScriptNumberSize - 3n)

export const getDeviceTypeFilter = (genericFilter, deviceType) => {
	// TODO: Doesn't this just reconstruct genericFilter?
	if (!genericFilter) return genericFilter
	if (typeof genericFilter !== "bigint") {
		throw new Error("Invalid genericFilter type (expected BigInt)")
	}
	let mask = 0n
	for (let i = 0; i < allNodeAlarmTypes.length; i++) {
		const bit = 1n << BigInt(i)
		if ((genericFilter & bit) !== 0n) {
			mask |= nodeAlarmEnumsByDeviceType[deviceType][allNodeAlarmTypes[i]]
		}
	}
	return mask
}

const nodeFlagEnums = {
	FAILED_EAST_LIMIT: 1n << 0n,
	CHARGER_TEMPERATURE_SHUTDOWN: 1n << 1n,
	HIGH_PRIORITY_STOW: 1n << 2n,
	LOW_PRIORITY_STOW: 1n << 3n,
	MISSED_CHECK_IN: 1n << 4n,
	BOD_RESET: 1n << 5n,
	ESTOP_POLL_DISABLED_TRACKING: 1n << 6n,
	ESTOP_IRQ_DISABLED_TRACKING: 1n << 7n,
	FAILED_WEST_LIMIT: 1n << 8n,
	ZIGBEE_REBROADCAST_DISABLED: 1n << 9n,
	BATTERY_CHARGE_CONDITIONING: 1n << 10n,
	DATA_REFRESHING: 1n << 11n,
	BATT_SOC_STOW_ENABLED: 1n << 12n,
	CHARGER_DISABLE_MOVE: 1n << 13n,
	WATCHDOG_RESET: 1n << 14n,
	INVALID_TRACKING_PARAM: 1n << 15n,
	OTA_CRC_CHECK_FAILED: 1n << 16n,
	OTA_FLASH_MEMORY_ERROR: 1n << 17n,
	OTA_IMG_BLOCKS_OVERFLOW: 1n << 18n,
	OTA_UNLOCK_FLASH_ERROR: 1n << 19n,
	CLEANING_MODE: 1n << 20n,
	TEMPERATURE_CALIBRATED: 1n << 21n,
	POWERBOOST_CALIBRATION_RUNNING: 1n << 22n,
	POWERBOOST_TARGET_ANGLE: 1n << 23n,
	POWERBOOST_DISABLE_CHARGER: 1n << 24n,
	FAILED_TO_MOVE_EAST: 1n << 25n,
	FAILED_TO_MOVE_WEST: 1n << 26n,
	OTA_RETRIES_REACHED: 1n << 27n, //Flag to indicate the node have failed too many OTA attempts
	NO_ANGLE_RCV_SINCE_RESET: 1n << 28n,
	LOW_TEMP_STOW: 1n << 29n, //This flag will be set when the system temperature is below the -30C threshold for the battery/
	READ_FLASH_ERROR: 1n << 30n,
	WRITE_FLASH_ERROR: 1n << 31n,
	ANGLE_RCV_OUT_OF_RANGE: 1n << 32n,
	BATT_LOW_DURING_MOTION: 1n << 33n,
	LOW_TEMP_FLAT: 1n << 34n,
	PANEL_OVER_VOLTAGE: 1n << 35n,
	EXTERNAL_INCLINOMETER: 1n << 36n,
	POWERBOOST_HEIGHT_OUT_OF_RANGE: 1n << 37n,
	WEATHERSMART_MODE: 1n << 38n,
	SECURITY_KEY_SWITCHED: 1n << 39n,
	BATTERY_OVER_VOLT_CHARGER_DISABLED: 1n << 40n,
	ACCEL_CALIBRATED_MMA8451Q: 1n << 41n,
	ACCEL_CALIBRATED_MC3419: 1n << 42n,
	ACCEL_CALIBRATED_ADXL367: 1n << 43n,
	OPTIMIZED_BACKTRACKING_ENABLED: 1n << 44n,
	SPLITCELL_BACKTRACKING_ENABLED: 1n << 45n,
	SMART_SPLITCELL_ENABLED: 1n << 46n,
	MASTER_LOW_TEMP_STOW: 1n << 47n,
	OTA_SECURE_BOOT_AUTHENTICATION_FAILED: 1n << 52n,
	SMART_CHARGER_OTA_UPDATE_FAILED: 1n << 53n,
	NO_COMMUNICATION_WITH_SMART_CHARGER: 1n << 54n,
	LCD_POSSIBLE_DEFECTED: 1n << 55n,
	KEY_PAD_STOW_MODE: 1n << 56n,
}

export const nodeFlagEnumsByDeviceType = {
	[deviceTypes.GAMECHANGE_GEN2]: nodeFlagEnums,
	[deviceTypes.GAMECHANGE_GEN3]: nodeFlagEnums,
	[deviceTypes.GAMECHANGE_GEN4]: {
		FAILED_EAST_LIMIT: 1n << 0n,
		CHARGER_TEMPERATURE_SHUTDOWN: 1n << 1n,
		HIGH_PRIORITY_STOW: 1n << 2n,
		LOW_PRIORITY_STOW: 1n << 3n,
		MISSED_CHECK_IN: 1n << 4n,
		BOD_RESET: 1n << 5n,
		ESTOP_POLL_DISABLED_TRACKING: 1n << 6n,
		ESTOP_IRQ_DISABLED_TRACKING: 1n << 7n,
		FAILED_WEST_LIMIT: 1n << 8n,
		ZIGBEE_REBROADCAST_DISABLED: 1n << 9n,
		BATTERY_CHARGE_CONDITIONING: 1n << 10n,
		DATA_REFRESHING: 1n << 11n,
		WATCHDOG_RESET: 1n << 12n,
		CHARGER_DISABLE_MOVE: 1n << 13n,
		INVALID_TRACKING_PARAM: 1n << 15n,
		OTA_CRC_CHECK_FAILED: 1n << 16n,
		OTA_FLASH_MEMORY_ERROR: 1n << 17n,
		OTA_IMG_BLOCKS_OVERFLOW: 1n << 18n,
		OTA_UNLOCK_FLASH_ERROR: 1n << 19n,
		CLEANING_MODE: 1n << 20n,
		TEMPERATURE_CALIBRATED: 1n << 21n,
		POWERBOOST_CALIBRATION_RUNNING: 1n << 22n,
		POWERBOOST_TARGET_ANGLE: 1n << 23n,
		POWERBOOST_DISABLE_CHARGER: 1n << 24n,
		FAILED_TO_MOVE_EAST: 1n << 25n,
		FAILED_TO_MOVE_WEST: 1n << 26n,
		OTA_RETRIES_REACHED: 1n << 27n, //Flag to indicate the node have failed too many OTA attempts
		NO_ANGLE_RCV_SINCE_RESET: 1n << 28n,
		LOW_TEMP_STOW: 1n << 29n, //This flag will be set when the system temperature is below the -30C threshold for the battery/
		READ_FLASH_ERROR: 1n << 30n,
		WRITE_FLASH_ERROR: 1n << 31n,
		ANGLE_RCV_OUT_OF_RANGE: 1n << 32n,
		BATT_LOW_DURING_MOTION: 1n << 33n,
		LOW_TEMP_FLAT: 1n << 34n,
		PANEL_OVER_VOLTAGE: 1n << 35n,
		EXTERNAL_INCLINOMETER: 1n << 36n,
		POWERBOOST_HEIGHT_OUT_OF_RANGE: 1n << 37n,
		WEATHERSMART_MODE: 1n << 38n,
		SECURITY_KEY_SWITCHED: 1n << 39n,
		BATTERY_OVER_VOLT_CHARGER_DISABLED: 1n << 40n,
		ACCEL_CALIBRATED_MMA8451Q: 1n << 41n,
		ACCEL_CALIBRATED_MC3419: 1n << 42n,
		ACCEL_CALIBRATED_ADXL367: 1n << 43n,
		OPTIMIZED_BACKTRACKING_ENABLED: 1n << 44n,
		SPLITCELL_BACKTRACKING_ENABLED: 1n << 45n,
		SMART_SPLITCELL_ENABLED: 1n << 46n,
		MASTER_LOW_TEMP_STOW: 1n << 47n,
		OTA_SECURE_BOOT_AUTHENTICATION_FAILED: 1n << 52n,
		SMART_CHARGER_OTA_UPDATE_FAILED: 1n << 53n,
		NO_COMMUNICATION_WITH_SMART_CHARGER: 1n << 54n,
		LCD_POSSIBLE_DEFECTED: 1n << 55n,
		KEY_PAD_STOW_MODE: 1n << 56n,
	},
	[deviceTypes.GAMECHANGE_GEN3_DUAL]: nodeFlagEnums,
}

const gameChangeAlarmModes = [
	{
		bit: nodeAlarmEnums.NONE,
		name: "None",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeAlarmEnums.LFP_BMS_UNRESPONSIVE,
		name: "LFP BMS Unresponsive",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeAlarmEnums.NO_TIME_SINCE_RESET,
		name: "No Time Since Reset",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeAlarmEnums.NO_COMM_WITH_MASTER,
		name: "No Communications",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeAlarmEnums.MOTOR_OVERCURRENT,
		name: "Actuator Over Current Shutdown",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeAlarmEnums.BATTERY_LOW_STOW,
		name: "Battery Low",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeAlarmEnums.BATTERY_CRITICAL_STOW,
		name: "Battery Critical",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeAlarmEnums.ANGLE_OUT_OF_SYSTEM_MAX_RANGE,
		name: "Angle Out of System Max Range",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeAlarmEnums.READ_FLASH_ERROR,
		name: "Memory Read Error",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeAlarmEnums.WRITE_FLASH_ERROR,
		name: "Memory Write Error",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeAlarmEnums.TRACKING_DISABLED,
		name: "Tracking Disabled",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeAlarmEnums.ESTOP_PUSHED,
		name: "E-Stop Pushed",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeAlarmEnums.NO_MOTION,
		name: "Actuator Not Responding",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeAlarmEnums.WRONG_DIRECTION,
		name: "Reverse Actuator Connection",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeAlarmEnums.BATTERY_OVERCHARGING,
		name: "Battery Overcharge Shutdown",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeAlarmEnums.OTA_CRC_CHECK_FAILED,
		name: "OTA CRC Check Failed",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeAlarmEnums.NODE_ASSIGNED_INIT_VALUES,
		name: "No Data Available (Node)",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeAlarmEnums.NOT_CHARGING,
		name: "Not Charging",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeAlarmEnums.OTA_IMG_PARAM_SAVE_ERROR,
		name: "OTA IMG Param Save",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeAlarmEnums.BAD_CHARGING_PANEL,
		name: "Bad Charging Panel",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeAlarmEnums.TABLE_OUTSIDE_TRACKING_LIMITS,
		name: "Table Outside Tracking Limits",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeAlarmEnums.MASTER_ASSIGNED_INIT_VALUES,
		name: "No Data Available (Master)",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeAlarmEnums.OTA_RETRIES_REACHED,
		name: "OTA Retries Reached",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeAlarmEnums.LOW_TEMP_STOW,
		name: "Low Temperature Stow",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeAlarmEnums.ANGLE_DEVIATION_FROM_MASTER,
		name: "Angle Deviation From Master",
		privilege: privileges.DEV,
	},
	{
		bit: nodeAlarmEnums.BATTERY_LOW_DURING_MOTION,
		name: "Battery Low During Motion",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeAlarmEnums.UNKNOWN_ACCELEROMETER_TYPE,
		name: "Unknown Accelerometer Type",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeAlarmEnums.BATTERY_MAINTENANCE,
		name: "Battery Maintenance",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeAlarmEnums.INCLINOMETER_DISCONNECTED,
		name: "Inclinometer Disconnected",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeAlarmEnums.TEMPERATURE_SHUTDOWN,
		name: "Temperature Shutdown",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeAlarmEnums.BATTERY_SHUTDOWN,
		name: "Battery Shutdown",
		privilege: privileges.VIEW,
	},
	{
		bit: NO_DATA_IN_DATABASE,
		name: "No Data Available in Server",
		privilege: privileges.VIEW,
	},
	{
		bit: DUPLICATE_NODEID,
		name: "Duplicate Node ID",
		privilege: privileges.VIEW,
	},
	{
		bit: OLD_DATA,
		name: "Old Data",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeAlarmEnums.LFP_BATTERY_SOC_LOW,
		name: "LFP Battery SOC Low",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeAlarmEnums.LFP_BATTERY_SOC_CRITICAL,
		name: "LFP Battery SOC Critical",
		privilege: privileges.VIEW,
	},
]

const nodeAlarmModeByDeviceType = {
	[deviceTypes.GAMECHANGE_GEN2]: gameChangeAlarmModes,
	[deviceTypes.GAMECHANGE_GEN3]: gameChangeAlarmModes,
	[deviceTypes.GAMECHANGE_GEN4]: gameChangeAlarmModes,
	[deviceTypes.GAMECHANGE_GEN3_DUAL_PRIMARY]: gameChangeAlarmModes,
	[deviceTypes.GAMECHANGE_GEN3_DUAL_AUX]: [
		{
			bit: nodeAlarmEnums.NONE,
			name: "None",
			privilege: privileges.VIEW,
		},
		{
			bit: nodeAlarmEnums.LFP_BMS_UNRESPONSIVE,
			name: "LFP BMS Unresponsive",
			privilege: privileges.GAMECHANGE,
		},
		{
			bit: nodeAlarmEnums.NO_COMM_WITH_MASTER,
			name: "No Communications",
			privilege: privileges.VIEW,
		},
		{
			bit: nodeAlarmEnums.MOTOR_OVERCURRENT,
			name: "Actuator Over Current Shutdown",
			privilege: privileges.VIEW,
		},
		{
			bit: nodeAlarmEnums.BATTERY_LOW_STOW,
			name: "Battery Low",
			privilege: privileges.VIEW,
		},
		{
			bit: nodeAlarmEnums.BATTERY_CRITICAL_STOW,
			name: "Battery Critical",
			privilege: privileges.VIEW,
		},
		{
			bit: nodeAlarmEnums.ANGLE_OUT_OF_SYSTEM_MAX_RANGE,
			name: "Angle Out of System Max Range",
			privilege: privileges.GAMECHANGE,
		},
		{
			bit: nodeAlarmEnums.READ_FLASH_ERROR,
			name: "Memory Read Error",
			privilege: privileges.GAMECHANGE,
		},
		{
			bit: nodeAlarmEnums.WRITE_FLASH_ERROR,
			name: "Memory Write Error",
			privilege: privileges.GAMECHANGE,
		},
		{
			bit: nodeAlarmEnums.TRACKING_DISABLED,
			name: "Tracking Disabled",
			privilege: privileges.VIEW,
		},
		{
			bit: nodeAlarmEnums.ESTOP_PUSHED,
			name: "E-Stop Pushed",
			privilege: privileges.VIEW,
		},
		{
			bit: nodeAlarmEnums.NO_MOTION,
			name: "Actuator Not Responding",
			privilege: privileges.VIEW,
		},
		{
			bit: nodeAlarmEnums.WRONG_DIRECTION,
			name: "Reverse Actuator Connection",
			privilege: privileges.VIEW,
		},
		{
			bit: nodeAlarmEnums.BATTERY_OVERCHARGING,
			name: "Battery Overcharge Shutdown",
			privilege: privileges.VIEW,
		},
		{
			bit: nodeAlarmEnums.OTA_CRC_CHECK_FAILED,
			name: "OTA CRC Check Failed",
			privilege: privileges.GAMECHANGE,
		},
		{
			bit: nodeAlarmEnums.NODE_ASSIGNED_INIT_VALUES,
			name: "No Data Available (Node)",
			privilege: privileges.GAMECHANGE,
		},
		{
			bit: nodeAlarmEnums.NOT_CHARGING,
			name: "Not Charging",
			privilege: privileges.VIEW,
		},
		{
			bit: nodeAlarmEnums.OTA_IMG_PARAM_SAVE_ERROR,
			name: "OTA IMG Param Save",
			privilege: privileges.GAMECHANGE,
		},
		{
			bit: nodeAlarmEnums.BAD_CHARGING_PANEL,
			name: "Bad Charging Panel",
			privilege: privileges.GAMECHANGE,
		},
		{
			bit: nodeAlarmEnums.TABLE_OUTSIDE_TRACKING_LIMITS,
			name: "Table Outside Tracking Limits",
			privilege: privileges.GAMECHANGE,
		},
		{
			bit: nodeAlarmEnums.MASTER_ASSIGNED_INIT_VALUES,
			name: "No Data Available (Master)",
			privilege: privileges.GAMECHANGE,
		},
		{
			bit: nodeAlarmEnums.OTA_RETRIES_REACHED,
			name: "OTA Retries Reached",
			privilege: privileges.GAMECHANGE,
		},
		{
			bit: nodeAlarmEnums.LOW_TEMP_STOW,
			name: "Low Temperature Stow",
			privilege: privileges.VIEW,
		},
		{
			bit: nodeAlarmEnums.ANGLE_DEVIATION_FROM_MASTER,
			name: "Angle Deviation From Master",
			privilege: privileges.DEV,
		},
		{
			bit: NO_DATA_IN_DATABASE,
			name: "No Data Available in Server",
			privilege: privileges.VIEW,
		},
		{
			bit: DUPLICATE_NODEID,
			name: "Duplicate Node ID",
			privilege: privileges.VIEW,
		},
		{
			bit: OLD_DATA,
			name: "Old Data",
			privilege: privileges.VIEW,
		},
	],
}

export const getNodeAlarmBitmask = (userPrivileges, deviceType) => {
	let alarmBitmask = 0n
	if (!nodeAlarmModeByDeviceType[deviceType]) return alarmBitmask
	nodeAlarmModeByDeviceType[deviceType].forEach((alarmMode) => {
		const bit = alarmMode.bit ?? alarmMode.OLD_DATA
		if ((userPrivileges & alarmMode.privilege) !== 0 && bit) {
			alarmBitmask = BigInt(BigInt(alarmBitmask) | BigInt(bit))
		}
	})
	return alarmBitmask
}

const getNodeAlarmsArray = (userPrivileges, deviceType, alarmBits) => {
	if (typeof alarmBits !== "bigint") {
		throw new Error("alarmBits must be a BigInt")
	}
	const activeAlarms = []
	nodeAlarmModeByDeviceType[deviceType].forEach((alarmMode) => {
		if (
			alarmMode.bit !== undefined &&
			(userPrivileges & alarmMode.privilege) !== 0 &&
			(alarmBits & alarmMode.bit) !== 0n
		) {
			activeAlarms.push(alarmMode.name)
		}
	})
	return activeAlarms
}

export const getNodeAlarmsString = (userPrivileges, deviceType) => (alarmBits) => {
	alarmBits = alarmBits ? BigInt(`0x${alarmBits}`) : 0n
	const activeAlarms = getNodeAlarmsArray(userPrivileges, deviceType, alarmBits)
	if (activeAlarms.length !== 0) {
		return activeAlarms.join(", ")
	} else {
		return "None"
	}
}

const getTemperatureCalibratedName = (nodeFirmwareVersion) => {
	// NOTE: After 3.19.0, this flag means "temperature has not been calibrated", not "temperature HAS been calibrated"
	if (!nodeFirmwareVersion) {
		return "Temperature Calibration Status Unknown"
	}
	if (semver.gte(nodeFirmwareVersion, "3.19.0")) {
		return "Temperature Not Calibrated"
	}
	return "Temperature Calibrated"
}

const nodeFlagModes = [
	{
		bit: nodeFlagEnums.TEMPERATURE_CALIBRATED,
		name: getTemperatureCalibratedName,
		privilege: privileges.VIEW,
	},
	{
		bit: nodeFlagEnums.POWERBOOST_CALIBRATION_RUNNING,
		name: "PowerBoost Calibration Running",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.POWERBOOST_TARGET_ANGLE,
		name: "PowerBoost Target Angle",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeFlagEnums.POWERBOOST_DISABLE_CHARGER,
		name: "PowerBoost Disable Charger",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.FAILED_EAST_LIMIT,
		name: "Failed to Reach Limit (East)",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.FAILED_WEST_LIMIT,
		name: "Failed to Reach Limit (West)",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.FAILED_TO_MOVE_EAST,
		name: "Failed to Move (East)",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeFlagEnums.CHARGER_TEMPERATURE_SHUTDOWN,
		name: "Charger Temp Shutdown",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.HIGH_PRIORITY_STOW,
		name: "Stow - High Priority",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeFlagEnums.LOW_PRIORITY_STOW,
		name: "Stow - Low Priority",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeFlagEnums.MISSED_CHECK_IN,
		name: "Missed Status Check-in",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.BOD_RESET,
		name: "BOD Reset",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.ESTOP_POLL_DISABLED_TRACKING,
		name: "E-stop - Poll Disabled",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.ESTOP_IRQ_DISABLED_TRACKING,
		name: "E-stop - IRQ Disabled",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.FAILED_TO_MOVE_WEST,
		name: "Failed to Move (West)",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeFlagEnums.ZIGBEE_REBROADCAST_DISABLED,
		name: "Zigbee Rebroadcast Disabled",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.BATTERY_CHARGE_CONDITIONING,
		name: "Battery Charge Conditioning",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.DATA_REFRESHING,
		name: "Data Refreshing",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeFlagEnums.BATT_SOC_STOW_ENABLED,
		name: "Battery SOC Stow Enabled",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.CHARGER_DISABLE_MOVE,
		name: "Battery Charger Disable Move",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.WATCHDOG_RESET,
		name: "Watchdog Reset",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.INVALID_TRACKING_PARAM,
		name: "Invalid Parameters",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.OTA_CRC_CHECK_FAILED,
		name: "OTA CRC Check Failed",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.OTA_FLASH_MEMORY_ERROR,
		name: "OTA Flash Memory Error",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.OTA_IMG_BLOCKS_OVERFLOW,
		name: "OTA Image Blocks Overflow",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.OTA_UNLOCK_FLASH_ERROR,
		name: "OTA Unlock Flash Error",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.CLEANING_MODE,
		name: "Cleaning Mode",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeFlagEnums.OTA_RETRIES_REACHED,
		name: "OTA Retries Reached",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.NO_ANGLE_RCV_SINCE_RESET,
		name: "No Angle Received Since Reset",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.LOW_TEMP_STOW,
		name: "Low Temperature Stow",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeFlagEnums.READ_FLASH_ERROR,
		name: "Read Flash Error",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.WRITE_FLASH_ERROR,
		name: "Write Flash Error",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.ANGLE_RCV_OUT_OF_RANGE,
		name: "Angle Received Out of Range",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeFlagEnums.BATT_LOW_DURING_MOTION,
		name: "Battery Low During Motion",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.LOW_TEMP_FLAT,
		name: "Low Temperature Flat",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeFlagEnums.PANEL_OVER_VOLTAGE,
		name: "Panel Overvoltage",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.EXTERNAL_INCLINOMETER,
		name: "External Inclinometer",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.POWERBOOST_HEIGHT_OUT_OF_RANGE,
		name: "Powerboost Height Out of Range",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.WEATHERSMART_MODE,
		name: "Weathersmart Mode",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeFlagEnums.SECURITY_KEY_SWITCHED,
		name: "Security Key Switched",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.BATTERY_OVER_VOLT_CHARGER_DISABLED,
		name: "Battery Overvoltage - Charger Disabled",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.OPTIMIZED_BACKTRACKING_ENABLED,
		name: "Optimized Backtracking Enabled",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.KEY_PAD_STOW_MODE,
		name: "Keypad Stow Mode",
		privilege: privileges.VIEW,
	},
	{
		bit: nodeFlagEnums.OTA_SECURE_BOOT_AUTHENTICATION_FAILED,
		name: "OTA Secure Boot Authentication Failed",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.SMART_CHARGER_OTA_UPDATE_FAILED,
		name: "Smart Charger OTA Updated Failed",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.NO_COMMUNICATION_WITH_SMART_CHARGER,
		name: "No Communication With Smart Charger",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.LCD_POSSIBLE_DEFECTED,
		name: "LCD Possibly Defective",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.ACCEL_CALIBRATED_MMA8451Q,
		name: "ACCEL CALIBRATED MMA8451Q",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.ACCEL_CALIBRATED_MC3419,
		name: "ACCEL CALIBRATED MC3419",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.ACCEL_CALIBRATED_ADXL367,
		name: "ACCEL CALIBRATED ADXL367",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.SPLITCELL_BACKTRACKING_ENABLED,
		name: "SPLITCELL BACKTRACKING ENABLED",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.SMART_SPLITCELL_ENABLED,
		name: "SMART SPLITCELL ENABLED",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.MASTER_LOW_TEMP_STOW,
		name: "MASTER LOW TEMP STOW",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: nodeFlagEnums.WATCHDOG_RESET,
		name: "WD Reset",
		privilege: privileges.GAMECHANGE,
	},
]

export const nodeFlagModesByDeviceType = {
	[deviceTypes.GAMECHANGE_GEN2]: nodeFlagModes,
	[deviceTypes.GAMECHANGE_GEN3]: nodeFlagModes,
	[deviceTypes.GAMECHANGE_GEN3_DUAL]: nodeFlagModes,
	[deviceTypes.GAMECHANGE_GEN4]: nodeFlagModes,
}

export const getNodeFlagBitmask = (userPrivileges, deviceType) => {
	let flagBitmask = 0n
	if (!nodeFlagModesByDeviceType[deviceType]) return 0n
	nodeFlagModesByDeviceType[deviceType].forEach((flagMode) => {
		if ((userPrivileges & flagMode.privilege) !== 0) {
			flagBitmask = flagBitmask | flagMode.bit
		}
	})
	return flagBitmask
}

export const getNodeFlagModesList = (userPrivileges, deviceType) => {
	let flagModesList = []
	if (!nodeFlagModesByDeviceType[deviceType]) return []
	nodeFlagModesByDeviceType[deviceType].forEach((flagMode) => {
		if ((userPrivileges & flagMode.privilege) !== 0) {
			flagModesList.push(flagMode)
		}
	})
	return flagModesList
}

export const getNodeFlagsString =
	(userPrivileges, deviceType) =>
	(flagBits, nodeFirmwareVersion = undefined) => {
		if (flagBits === undefined) {
			return "Loading..."
		}
		flagBits = BigInt(`0x${flagBits}`)

		const activeFlags = []

		for (const flagMode of nodeFlagModesByDeviceType[deviceType]) {
			if ((userPrivileges & flagMode.privilege) !== 0 && (BigInt(flagBits) & flagMode.bit) !== 0n) {
				let name = flagMode.name
				if (typeof name === "function") name = name(nodeFirmwareVersion)
				activeFlags.push(name)
			}
		}

		if (activeFlags.length !== 0) {
			return activeFlags.join(", ")
		} else {
			return "None"
		}
	}

export const masterAlarmEnums = {
	NONE: 0n,
	WRITE_FLASH_ERROR: 1n << 0n,
	NODE_ID_NAND_FLASH_ERROR: 1n << 1n,
	STOW_COORD_NAND_FLASH_ERROR: 1n << 2n,
	PARAM_NAND_FLASH_ERROR: 1n << 3n,
	EXT_CLOCK_I2C_COMM_ERROR: 1n << 4n,
	FUEL_GAUGE_I2C_COMM_ERROR: 1n << 5n,
	LOW_TEMPERATURE_STOW_ACTIVE: 1n << 6n,
	WIND_SENSOR_DISABLED: 1n << 7n,
	THUNDERSMART_ACTIVE: 1n << 8n,
	HAILSTOW_ACTIVE: 1n << 9n,
	WEATHERSMART_ACTIVE: 1n << 10n,
	ROBOT_CLEANING_ACTIVE: 1n << 11n,
	WIND_SENSOR_DISCONNECTED: 1n << 12n,
	SNOW_SENSOR_DISCONNECT: 1n << 13n,
	CRITICAL_BATTERY: 1n << 14n,
	AC_STATUS: 1n << 15n,
	SMART_STOW_ACTIVE: 1n << 16n,
	BATT_NOT_CHARGING: 1n << 17n,
	BATT_OVERCHARGING: 1n << 18n,
	BAD_CHARGING_PANEL: 1n << 19n,
	CHARGING_PANEL_OVERVOLTAGE: 1n << 20n,
	MANUAL_LOW_PRIORITY_STOW: 1n << 21n,
	KEYPAD_STOW_MODE: 1n << 22n,
	CLEANING_MODE: 1n << 23n,
	NO_COMM_WITH_NODES: 1n << 24n,
	LFP_BATT_TEMP_SHUTDOWN: 1n << 25n,
	NODES_LOW_TEMP_SHUTDOWN: 1n << 26n,
	NODES_HIGH_TEMP_SHUTDOWN: 1n << 27n,
	APP_VALIDATION_FAILED: 1n << 28n,
	LFP_BMS_UNRESPONSIVE: 1n << 29n,
	LFP_BATT_SHUTDOWN: 1n << 30n,
	SNOW_STOW: 1n << 31n,
	FLOOD_STOW: 1n << 32n,
	SOLAR_GRAZING_STOW: 1n << 33n,
	RAIN_STOW: 1n << 34n,
	HIGH_PRIORITY_MANUAL_STOW: 1n << 35n,
}

const masterAlarmModes = [
	{
		bit: masterAlarmEnums.LFP_BATT_SHUTDOWN,
		name: "LFP Battery Shutdown",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.LFP_BMS_UNRESPONSIVE,
		name: "Master LFP BMS Unresponsive",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.APP_VALIDATION_FAILED,
		name: "App Validation Failed",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.NODES_HIGH_TEMP_SHUTDOWN,
		name: "Nodes High Temp Shutdown",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.NODES_LOW_TEMP_SHUTDOWN,
		name: "Nodes Low Temp Shutdown",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.LFP_BATT_TEMP_SHUTDOWN,
		name: "LFP Battery Temp Shutdown",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.NO_COMM_WITH_NODES,
		name: "No Communication With Nodes",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.CLEANING_MODE,
		name: "Cleaning Mode",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.KEYPAD_STOW_MODE,
		name: "Keypad Stow Mode",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.MANUAL_LOW_PRIORITY_STOW,
		name: "Manual Low Priority Stow",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.CHARGING_PANEL_OVERVOLTAGE,
		name: "Charging Panel Overvoltage",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.BAD_CHARGING_PANEL,
		name: "Bad Charging Panel",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.BATT_OVERCHARGING,
		name: "Battery Overcharging",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.BATT_NOT_CHARGING,
		name: "Battery Not Charging",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.SMART_STOW_ACTIVE,
		name: "Smart Stow Active",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.AC_STATUS,
		name: "AC Power Status",
		privilege: privileges.VIEW,
	},
	{
		bit: masterAlarmEnums.CRITICAL_BATTERY,
		name: "Master Controller Critical Battery",
		privilege: privileges.VIEW,
	},
	{
		bit: masterAlarmEnums.SNOW_SENSOR_DISCONNECT,
		name: "Snow Sensor Disconnected",
		privilege: privileges.VIEW,
	},
	{
		bit: masterAlarmEnums.WIND_SENSOR_DISCONNECTED,
		name: "Wind Sensor Disconnected",
		privilege: privileges.VIEW,
	},
	{
		bit: masterAlarmEnums.ROBOT_CLEANING_ACTIVE,
		name: "Robot Cleaning Active",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.WEATHERSMART_ACTIVE,
		name: "WeatherSmart Active",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.HAILSTOW_ACTIVE,
		name: "HailStow Active",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.THUNDERSMART_ACTIVE,
		name: "ThunderSmart Active",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.WIND_SENSOR_DISABLED,
		name: "Wind Sensor Disabled",
		privilege: privileges.VIEW,
	},
	{
		bit: masterAlarmEnums.LOW_TEMPERATURE_STOW_ACTIVE,
		name: "Low Temperature Stow Active",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.FUEL_GAUGE_I2C_COMM_ERROR,
		name: "Fuel Gauge I2C Communication Error",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.EXT_CLOCK_I2C_COMM_ERROR,
		name: "External Clock I2C Communication Error",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.PARAM_NAND_FLASH_ERROR,
		name: "Master Parameter NAND Flash Error",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.STOW_COORD_NAND_FLASH_ERROR,
		name: "Master Stow Coordinate NAND Flash Error",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.NODE_ID_NAND_FLASH_ERROR,
		name: "Master Node ID NAND Flash Error",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.WRITE_FLASH_ERROR,
		name: "Master Write Flash Error",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.SNOW_STOW,
		name: "Master Snow Stow",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.FLOOD_STOW,
		name: "Master Flood Stow",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.SOLAR_GRAZING_STOW,
		name: "Master Solar Grazing Stow",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.RAIN_STOW,
		name: "Master Rain Stow",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterAlarmEnums.HIGH_PRIORITY_MANUAL_STOW,
		name: "High Priority Manual Stow",
		privilege: privileges.GAMECHANGE,
	},
]

const getMasterAlarmsArray = (userPrivileges, alarmBits) => {
	let activeAlarms = []
	masterAlarmModes.forEach((alarmMode) => {
		if ((userPrivileges & alarmMode.privilege) !== 0 && (alarmBits & BigInt(alarmMode.bit)) !== 0n) {
			activeAlarms.push(alarmMode.name)
		}
	})
	return activeAlarms
}

/**
 * Get the index of the first bit set in a bitmask. For example, converts 0b1000 to 3.
 * @param mask
 * @returns {bigint}
 */
export function getBitIndex(mask) {
	const binaryString = mask.toString(2)
	const reversed = binaryString.split("").reverse().join("")
	return BigInt(reversed.indexOf("1"))
}

export const getMasterAlarmBitmask = (userPrivileges) => {
	let masterAlarmBitmask = 0n
	if (!masterAlarmModes) return 0n
	masterAlarmModes.forEach((alarmMode) => {
		if ((userPrivileges & alarmMode.privilege) !== 0) {
			masterAlarmBitmask = masterAlarmBitmask | alarmMode.bit
		}
	})
	return masterAlarmBitmask
}

export const getMasterAlarmModesList = (userPrivileges) => {
	let masterModesList = []
	if (!masterAlarmModes) return []
	masterAlarmModes.forEach((alarmMode) => {
		if ((userPrivileges & alarmMode.privilege) !== 0) {
			masterModesList.push(alarmMode)
		}
	})
	return masterModesList
}

export const getMasterAlarmsString = (userPrivileges) => (alarmBits) => {
	alarmBits = BigInt(`0x${alarmBits}`)
	const activeAlarms = getMasterAlarmsArray(userPrivileges, alarmBits)
	if (activeAlarms.length !== 0) {
		return activeAlarms.join(", ")
	} else {
		return "None"
	}
}

export const masterFlagEnums = {
	NONE: 0n,
	FLAG_RAIN_STOW: 1n << 1n,
	SOLAR_GRAZING_STOW: 1n << 2n,
	RECALIBRATE_SNOW_SENSOR: 1n << 3n,
	FAILED_TO_RCV_WIND_READING: 1n << 4n,
	SNOW_DATA_FROM_SERVER: 1n << 5n,
	SNOW_SENSOR_DEVIATION: 1n << 6n,
	WIND_DATA_FROM_SERVER: 1n << 7n,
	SNOW_READING_OUT_OF_RANGE: 1n << 8n,
	NIGHTLY_OTA_CHECK_ENABLED: 1n << 9n,
	NODE_CHARGER_CONTROL_ENABLED: 1n << 10n,
	WIND_SENSOR_DEVIATION: 1n << 11n, // NOTE: old NODE_CHARGER_CONTROL_ENABLED flag
	CALL_AND_RESPOND_OVER_LIMIT: 1n << 12n, // NOTE- 03/23/2023: WeatherSmart moved to system alarms for new auto smart stow flow
	CLEANING_MODE: 1n << 13n,
	SNOW_FLOOD_SENSOR_BASELINE_ADJUSTED: 1n << 14n,
	SNOW_STOW_DISABLED: 1n << 15n,
	LFP_BATTERY: 1n << 16n,
	BATTERY_MAINTENANCE: 1n << 17n,
	LFP_BATTERY_HEATER_ENABLED: 1n << 18n,
	POWER_SAVE_DISABLED: 1n << 19n,
	WIND_DATA_FROM_MASTER: 1n << 20n,
	BATTERY_LOW: 1n << 21n,
	CHARGER_TEMPERATURE_SHUTDOWN: 1n << 22n,
	INVALID_TRACKING_PARAMETERS: 1n << 23n,
	UNDER_LOW_TEMPERATURE: 1n << 24n,
	OVER_HIGH_TEMPERATURE: 1n << 25n,
	POSSIBLE_DEFECTIVE_LCD: 1n << 26n,
	WRONG_SECURITY_KEY: 1n << 27n,
}

const masterFlagModes = [
	{
		bit: masterFlagEnums.NONE,
		name: "None",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.UNDER_LOW_TEMPERATURE,
		name: "Master Low Temperature",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.FLAG_RAIN_STOW,
		name: "Flag Rain Stow",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.SOLAR_GRAZING_STOW,
		name: "Solar Grazing Stow",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.RECALIBRATE_SNOW_SENSOR,
		name: "Recalibrate Snow Sensor",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.WIND_DATA_FROM_SERVER,
		name: "Wind Data From Server",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.NIGHTLY_OTA_CHECK_ENABLED,
		name: "Nightly OTA Check Enabled",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterFlagEnums.WIND_SENSOR_DEVIATION,
		name: "Wind Sensor Deviation",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterFlagEnums.CALL_AND_RESPOND_OVER_LIMIT,
		name: "Call And Respond Over Limit",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterFlagEnums.SNOW_FLOOD_SENSOR_BASELINE_ADJUSTED,
		name: "Snow/Flood Sensor Baseline Adjusted",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterFlagEnums.SNOW_STOW_DISABLED,
		name: "Snow Stow Disabled",
		privilege: privileges.GAMECHANGE,
	},
	{
		bit: masterFlagEnums.LFP_BATTERY,
		name: "LFP Battery",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.BATTERY_MAINTENANCE,
		name: "Battery Maintenance",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.LFP_BATTERY_HEATER_ENABLED,
		name: "LFP Battery Heater Enabled",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.FAILED_TO_RCV_WIND_READING,
		name: "Failed to receive wind reading",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.SNOW_DATA_FROM_SERVER,
		name: "Snow data from server",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.SNOW_SENSOR_DEVIATION,
		name: "Sensor deviation",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.SNOW_READING_OUT_OF_RANGE,
		name: "Snow Reading Out Of Range",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.NODE_CHARGER_CONTROL_ENABLED,
		name: "Node charger control enabled",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.CLEANING_MODE,
		name: "Cleaning mode",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.POWER_SAVE_DISABLED,
		name: "Power Save Disabled",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.WIND_DATA_FROM_MASTER,
		name: "Wind Data From Master",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.BATTERY_LOW,
		name: "Battery Low",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.CHARGER_TEMPERATURE_SHUTDOWN,
		name: "Charger Temperature Shutdown",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.INVALID_TRACKING_PARAMETERS,
		name: "Invalid Tracking Parameters",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.UNDER_LOW_TEMPERATURE,
		name: "Under Low Temperature",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.OVER_HIGH_TEMPERATURE,
		name: "Over High Temperature",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.POSSIBLE_DEFECTIVE_LCD,
		name: "Possible Defective LCD",
		privilege: privileges.VIEW,
	},
	{
		bit: masterFlagEnums.WRONG_SECURITY_KEY,
		name: "Wrong Security Key",
		privilege: privileges.VIEW,
	},
]

const getMasterFlagsArray = (userPrivileges, flagBits) => {
	let activeFlags = []
	masterFlagModes.forEach((flagMode) => {
		if ((userPrivileges & flagMode.privilege) !== 0 && (BigInt(flagBits) & flagMode.bit) !== 0n) {
			activeFlags.push(flagMode.name)
		}
	})
	return activeFlags
}

export const getMasterFlagBitmask = (userPrivileges) => {
	let masterFlagBitmask = 0n
	if (!masterFlagModes) return 0n
	masterFlagModes.forEach((flagMode) => {
		if ((userPrivileges & flagMode.privilege) !== 0) {
			masterFlagBitmask = masterFlagBitmask | flagMode.bit
		}
	})
	return masterFlagBitmask
}

export const getMasterFlagModesList = (userPrivileges) => {
	let masterModesList = []
	if (!masterFlagModes) return []
	masterFlagModes.forEach((flagMode) => {
		if ((userPrivileges & flagMode.privilege) !== 0) {
			masterModesList.push(flagMode)
		}
	})
	return masterModesList
}

export const getMasterFlagsString = (userPrivileges) => (flagBits) => {
	flagBits = parseInt(flagBits, 16)
	const activeFlags = getMasterFlagsArray(userPrivileges, flagBits)
	if (activeFlags && activeFlags.length !== 0) {
		return activeFlags.join(", ")
	} else {
		return "None"
	}
}

const gameChangeMasterBootTypes = {
	GENERAL_RESET: 0,
	BACKUP_RESET: 1,
	WATCHDOG_RESET: 2,
	SOFTWARE_RESET: 3,
	USER_RESET: 4,
}

const gameChangeBootTypeDescriptions = {
	[gameChangeMasterBootTypes.GENERAL_RESET]: "General Reset",
	[gameChangeMasterBootTypes.BACKUP_RESET]: "Backup Reset",
	[gameChangeMasterBootTypes.WATCHDOG_RESET]: "Watchdog Reset",
	[gameChangeMasterBootTypes.SOFTWARE_RESET]: "Software Reset",
	[gameChangeMasterBootTypes.USER_RESET]: "User Reset",
}

export const bootTypeDescriptions = {
	[deviceTypes.GAMECHANGE_GEN2]: gameChangeBootTypeDescriptions,
	[deviceTypes.GAMECHANGE_GEN3]: gameChangeBootTypeDescriptions,
	[deviceTypes.GAMECHANGE_GEN4]: gameChangeBootTypeDescriptions,
	[deviceTypes.GAMECHANGE_GEN3_DUAL]: gameChangeBootTypeDescriptions,
}

const gameChangeTrackingModes = {
	UNKNOWN: 0,
	TRACKING: 1,
	ANTISHADING: 2,
	NIGHT: 3,
	SMART_STOW: 4,
	KEEP_ENABLED: 5,
}

export const trackingModes = {
	[deviceTypes.GAMECHANGE_GEN2]: gameChangeTrackingModes,
	[deviceTypes.GAMECHANGE_GEN3]: gameChangeTrackingModes,
	[deviceTypes.GAMECHANGE_GEN4]: gameChangeTrackingModes,
	[deviceTypes.GAMECHANGE_GEN3_DUAL]: gameChangeTrackingModes,
}

const gameChangeTrackingModeDescriptions = {
	[gameChangeTrackingModes.UNKNOWN]: "Unknown State",
	[gameChangeTrackingModes.TRACKING]: "Tracking",
	[gameChangeTrackingModes.ANTISHADING]: "Anti-shading",
	[gameChangeTrackingModes.NIGHT]: "Night",
	[gameChangeTrackingModes.SMART_STOW]: "Stow",
	[gameChangeTrackingModes.KEEP_ENABLED]: "Manual Stow",
}

export const trackingModeDescriptions = {
	[deviceTypes.GAMECHANGE_GEN2]: gameChangeTrackingModeDescriptions,
	[deviceTypes.GAMECHANGE_GEN3]: gameChangeTrackingModeDescriptions,
	[deviceTypes.GAMECHANGE_GEN4]: gameChangeTrackingModeDescriptions,
	[deviceTypes.GAMECHANGE_GEN3_DUAL]: gameChangeTrackingModeDescriptions,
}

const gameChangeMasterStowModes = {
	NONE: 0n,
	UNKNOWN: 1n << 0n,
	MANUAL_OVERRIDE: 1n << 1n,
	WIND: 1n << 2n,
	HAIL: 1n << 3n,
	SENSOR_DISCONNECT_WIND: 1n << 4n,
	SENSOR_DISCONNECT_SNOW: 1n << 5n,
	MASTER_LOW_BATTERY: 1n << 6n,
	SNOW: 1n << 7n,
	SNOW_FORECAST_STOW: 1n << 8n,
	WATER: 1n << 9n,
	THUNDERSMART: 1n << 10n,
	LOW_TEMPERATURE_STOW: 1n << 11n,
	MASTER_HARDWARE_FAULT: 1n << 12n,
	ROBOT_CLEANING_MODE: 1n << 13n,
	MANUAL_OVERRIDE_LOW_PRIORITY: 1n << 14n,
	SOLAR_GRAZING_STOW: 1n << 15n,
	CLEANING_MODE: 1n << 16n,
	RAIN_STOW: 1n << 17n,
	WEATHERSMART: 1n << 18n,
	STOW_ANGLE_OVERNIGHT_HOLD: 1n << 19n,
}

export const masterStowModes = {
	[deviceTypes.GAMECHANGE_GEN2]: gameChangeMasterStowModes,
	[deviceTypes.GAMECHANGE_GEN3]: gameChangeMasterStowModes,
	[deviceTypes.GAMECHANGE_GEN4]: gameChangeMasterStowModes,
	[deviceTypes.GAMECHANGE_GEN3_DUAL]: gameChangeMasterStowModes,
}

const gameChangeStowModeDescriptions = {
	[gameChangeMasterStowModes.NONE]: "None",
	[gameChangeMasterStowModes.UNKNOWN]: "Unknown",
	[gameChangeMasterStowModes.MANUAL_OVERRIDE]: "Manual Override - High Priority",
	[gameChangeMasterStowModes.WIND]: "Wind",
	[gameChangeMasterStowModes.HAIL]: "Hail",
	[gameChangeMasterStowModes.SENSOR_DISCONNECT_WIND]: "Wind Sensor Disconnect",
	[gameChangeMasterStowModes.SENSOR_DISCONNECT_SNOW]: "Snow Sensor Disconnect",
	[gameChangeMasterStowModes.MASTER_LOW_BATTERY]: "Master Low Battery",
	[gameChangeMasterStowModes.SNOW]: "Snow",
	[gameChangeMasterStowModes.SNOW_FORECAST_STOW]: "Snow Forecast Stow",
	[gameChangeMasterStowModes.WATER]: "Water",
	[gameChangeMasterStowModes.THUNDERSMART]: "Thundersmart",
	[gameChangeMasterStowModes.LOW_TEMPERATURE_STOW]: "Low Temperature Stow",
	[gameChangeMasterStowModes.MASTER_HARDWARE_FAULT]: "Master Hardware Fault",
	[gameChangeMasterStowModes.ROBOT_CLEANING_MODE]: "Robot Cleaning Mode",
	[gameChangeMasterStowModes.MANUAL_OVERRIDE_LOW_PRIORITY]: "Manual Override - Low Priority",
	[gameChangeMasterStowModes.SOLAR_GRAZING_STOW]: "Solar Grazing Stow",
	[gameChangeMasterStowModes.CLEANING_MODE]: "Cleaning Mode",
	[gameChangeMasterStowModes.RAIN_STOW]: "Rain Stow",
	[gameChangeMasterStowModes.WEATHERSMART]: "Weathersmart",
	[gameChangeMasterStowModes.STOW_ANGLE_OVERNIGHT_HOLD]: "Overnight Hold",
}

export const stowModeDescriptions = {
	[deviceTypes.GAMECHANGE_GEN2]: gameChangeStowModeDescriptions,
	[deviceTypes.GAMECHANGE_GEN3]: gameChangeStowModeDescriptions,
	[deviceTypes.GAMECHANGE_GEN4]: gameChangeStowModeDescriptions,
	[deviceTypes.GAMECHANGE_GEN3_DUAL]: gameChangeStowModeDescriptions,
}

const getEnabledStowModesArray = (deviceType, enabledStowModes) => {
	const enabledStowModesList = []

	Object.values(masterStowModes[deviceType]).forEach((stowMode) => {
		if ((enabledStowModes & stowMode) !== 0n) {
			enabledStowModesList.push(stowModeDescriptions[deviceType][stowMode])
		}
	})

	return enabledStowModesList
}

export const getEnabledStowModesString = (deviceType) => (enabledStowModes) => {
	const enabledStowModesArray = getEnabledStowModesArray(deviceType, BigInt(`0x${enabledStowModes}`))
	if (enabledStowModesArray.length !== 0) {
		return enabledStowModesArray.join(", ")
	} else {
		return "None"
	}
}

export const getSmartStowModeString = (smartStowMode) => {
	const autoSmartStowMode = BigInt(smartStowMode || 0)
	return autoSmartStowMode === BigInt("0x7859") ? "Enabled" : "Disabled"
}

export const getPowerboostStatus = (powerboostStatus) => {
	if (powerboostStatus === undefined || powerboostStatus === null) return "None"
	return powerboostStatus ? "Enabled" : "Disabled"
}

export const getOptimizedBackTracking = (optimizedBacktracking) => {
	if (optimizedBacktracking === undefined || optimizedBacktracking === null) return "None"
	return optimizedBacktracking ? "Enabled" : "Disabled"
}

export const WindSensorTypeEnum = {
	0: "InSpeed",
	1: "ET-40RS",
	2: "ET-3250",
	3: "Barani - MeteoWind Compact",
	4: "Gill WindSonic 1405",
}

export const masterGen3PowerReadStatus = {
	VOTLAGE_READ_ERROR: 1n << 1n,
	CURRENT_READ_ERROR: 1n << 2n,
	CHARGER_TEMP_READ_ERROR: 1n << 3n,
	BOARD_TEMP_READ_ERROR: 1n << 4n,
}

export const getZigbeeAmplifierStatus = (zigbeeAmplifierStatus) => {
	if (zigbeeAmplifierStatus == null) return "None"
	return Number(zigbeeAmplifierStatus) ? "Enabled" : "Disabled"
}

export const SnowSensorTypeEnum = {
	0: "MaxSonar",
	1: "SNOdar",
	2: "NovaLynx",
}
